import type { ElementRouter } from "replo-publisher/src/trpc/routers/element";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: elementRouter,
  client: elementClient,
  utils: elementUtils,
  options: elementOptions,
} = createTrpcRouterConfig<ElementRouter>({
  path: "element",
  queryClient: getNamespacedQueryClient("element"),
});

export { elementClient, elementRouter, elementUtils, elementOptions };
